export default Object.freeze({
  /**
   * The UI element has been embedded within Relief Roster (Impala) on the Candidate page
   */
  ReliefRosterCandidateView: 'rr.candidateView',
})
